import { render, staticRenderFns } from "./WorldTerrainMap.vue?vue&type=template&id=8d0f9100&scoped=true"
import script from "./WorldTerrainMap.vue?vue&type=script&lang=js"
export * from "./WorldTerrainMap.vue?vue&type=script&lang=js"
import style0 from "./WorldTerrainMap.vue?vue&type=style&index=0&id=8d0f9100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0f9100",
  null
  
)

export default component.exports